module.exports = __webpack_public_path__ + "static/group2_4-8f271db395bbfd85c243edabbd6829de.webp";